/*
 * @Author: lixiaoli lxl1596717219@163.com
 * @Date: 2023-06-28 11:40:25
 * @LastEditors: lixiaoli lxl1596717219@163.com
 * @LastEditTime: 2023-07-05 15:24:09
 * @FilePath: \visualization-platform-jiangsu\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import Router from './Router/index.js'
import Info from './Serves/Info.js'
//引入饿了么ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入echarts
// import echarts from 'echarts'
// import * as echarts from 'echarts'
import * as echarts from 'echarts/lib/echarts';

import axios from 'axios'
import VueAxios from 'vue-axios'
import '../static/css/common.css'
import { HappyScroll } from 'vue-happy-scroll'
//自定义组件名
Vue.component('happy-scroll', HappyScroll)
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
import './assets/css/style.css'//自己的样式

//兼容ie
import 'babel-polyfill'
import Vant from 'vant';

import common from './assets/js/common.js'
Vue.prototype.$common = common 

Vue.use(Vant);

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

//登录滑块验证码插件
import SliderVerify from 'slider-verify-dt'
Vue.use(SliderVerify)

// // 引入各种图表，图表后缀都为 Chart
// import { BarChart, PieChart } from "echarts/charts";  //这里我引用两个类型的图表
// // 引入提示框，标题，直角坐标系等组件，组件后缀都为 Component
// import {
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   LegendComponent,
//   // GeoCoComponent
// } from "echarts/components";
// // 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
// import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
// echarts.use([
//   TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   LegendComponent,
//   BarChart,
//   PieChart,
//   CanvasRenderer,
// ]);
Vue.prototype.$http = axios
//全局存token
Vue.prototype.Info = Info
Vue.prototype.bus = new Vue()

//定义全局变量
// vuex的使用
import store from './store'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(ElementUI,axios,VueAxios);
new Vue({
  store,
  render: h => h(App),
  router:Router,
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js